import Axios from "axios";

export const SelectFournisseur = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/fournisseurs?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "FOURNISSEUR_SELECT", payload: response.data });
    });
  };
};
